import React from 'react';
import {
  FDBodyText, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const ChartTooltip = ({ emphasizedItem }) => {
  return (
    <div style={{
      maxWidth: '150px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0,
    }}
    >
      <FDTitleText align="center" value={emphasizedItem.meta?.name} size="sm" />
      <FDBodyText align="center" value={emphasizedItem.meta?.amountDescription} size="sm" />
      <FDBodyText align="center" value={emphasizedItem.meta?.fundedPercentDescription} size="sm" />
    </div>
  );
};

ChartTooltip.defaultProps = {
  emphasizedItem: {},
};

ChartTooltip.propTypes = {
  emphasizedItem: PropTypes.object,
};

export default ChartTooltip;
